/**
 * Tracks SPA route changes and forwards them to PostHog as $pageview events.
 *
 * Must render INSIDE the BrowserRouter (it uses useLocation()).
 * Returns null - it's a side-effect component.
 *
 * The capture call is a no-op when PostHog is not initialized, so this
 * tracker is safe to mount unconditionally.
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { capturePageview, isPostHogEnabled } from '@/observability/posthog'

export function RouterPageviewTracker(): null {
  const location = useLocation()

  useEffect(() => {
    if (!isPostHogEnabled()) return
    capturePageview(location.pathname, location.search)
  }, [location.pathname, location.search])

  return null
}

export default RouterPageviewTracker
